import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { RouterModule } from '@angular/router';

import { FullscreenWindowModule } from '@libs/src/fullscreen-window/fullscreen-window.module';
import { LogoSquareModule } from '@libs/src/logo-square/logo-square.module';
import { CustomerInfoModule } from '@static-client/src/app/customer-info/customer-info.module';
import { FooterModule } from '@static-client/src/app/footer/footer.module';

import { HeroIllustrationComponent } from './hero-illustration/hero-illustration.component';
import { LandingComponent } from './landing.component';

import { AuthService } from '../auth.service';
import { PartnershipTermsModule } from '../partnership-terms/partnership-terms.module';
import { PrivacyModule } from '../privacy/privacy.module';
import { TermsModule } from '../terms/terms.module';
import { WindowRefService } from '../window-ref.service';

@NgModule({
  imports: [
    CommonModule,
    FlexLayoutModule,
    FooterModule,
    FormsModule,
    FullscreenWindowModule,
    LogoSquareModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatSnackBarModule,
    PartnershipTermsModule,
    PrivacyModule,
    ReactiveFormsModule,
    RouterModule.forChild([]),
    TermsModule,
    CustomerInfoModule,
    MatDialogModule,
  ],
  declarations: [HeroIllustrationComponent, LandingComponent],
  providers: [AuthService, WindowRefService],
})
export class LandingModule {}
